'use strict';

var _ = require('lodash');
var lowestCompetitorIconsTemplate = _.template(require('../templates/lowest-competitor-icons.html'));
var CompetitorDataGridColumnFactory = function CompetitorDataGridColumnFactory() {
  var compTypeRenderer = function compTypeRenderer(row, columnfield, value, defaultvalue, column, rowdata) {
    return defaultvalue.replace('><', '>' + lowestCompetitorIconsTemplate({
      isLowestCompetitor: rowdata.isLowestCompetitor,
      isLowestCompetitorTOD: rowdata.isLowestCompetitorTOD
    }) + '<');
  };
  var renderers = {
    compTypeRenderer: compTypeRenderer
  };
  function GridColumn(column) {
    _.assignIn(this, column);
    if (column.customRenderer !== undefined) {
      this.cellsrenderer = renderers[column.customRenderer];
    }
  }
  return GridColumn;
};
CompetitorDataGridColumnFactory.$inject = [];
module.exports = CompetitorDataGridColumnFactory;